import { createElement } from "react";
import ReactDOMServer from "react-dom/server";

import { downloadAsCSV } from "@utils/downloadAsCSV";
import { downloadAsPDF } from "@utils/downloadAsPDF";
import DetailsPrint from "./DetailsPrint";

export type ExportFormat = "csv" | "pdf";

/** A tab's label–value rows, as its DetailList shows them. */
export type DetailRows = [string, string | undefined][];

/** Downloads a profile tab's rows as the tab labels them: one CSV column, or one PDF line, per row. */
export const exportDetails = async ({
  title,
  rows,
  fileName,
  format,
}: {
  title?: string;
  rows: DetailRows;
  fileName: string;
  format: ExportFormat;
}) => {
  const name = `${fileName}-${Date.now().toString()}`;

  if (format === "pdf") {
    await downloadAsPDF({
      data: ReactDOMServer.renderToString(
        createElement(DetailsPrint, { title, rows }),
      ),
      fileName: name,
    });
    return;
  }

  downloadAsCSV({
    data: [
      Object.fromEntries(rows.map(([label, value]) => [label, value ?? ""])),
    ],
    fileName: name,
  });
};
